import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable, throwError} from "rxjs";
import {catchError, tap, map} from "rxjs/operators";
 
import {StreamProject, StreamAccessKey, StreamChat, RestreamItem} from "../interfaces";
import {StatService} from "./stat.service";
@Injectable({providedIn: 'root'})
export class StreamsService {

  constructor(private http: HttpClient, private statService: StatService){
  }

  fetch():Observable<StreamProject[]>{
    return this.http.get<StreamProject[]>('/api/stream')
  }

  getById(id:string):Observable<StreamProject>{
    return this.http.get<StreamProject>(`/api/stream/${id}`)
  }



  create(streamType?:any): Observable<StreamProject>{
    const formData = new FormData()
    if(streamType){
      formData.append('streamType', streamType)
    } 
    return this.http.post<StreamProject>('/api/stream', formData)
  }
  
  delete(id:string):Observable<StreamProject>{
    return this.http.delete<StreamProject>(`/api/stream/${id}`)
  }


  setAccessLevel(id:string, level:number): Observable<StreamProject>{
 
    return this.http.patch<StreamProject>(`/api/stream/access_level/${id}`, {
      level
    })
  }

  
  generateAccessKeys(id:string, quantity:number):Observable<StreamAccessKey[]>{
    return this.http.post<StreamAccessKey[]>(`/api/stream/generate_keys/${id}`,{
      quantity
    })
  }


 uploadListAccessKeys(id:string, data:any):Observable<StreamAccessKey[]>{
    return this.http.post<StreamAccessKey[]>(`/api/stream/load_list_keys/${id}`,{
      keys:data
    })
  }

//
  getAllAccessKeys(stream:string){
    return this.http.get<StreamAccessKey[]>(`/api/stream/get_all_access_keys/${stream}`)
  }

  clearAllAccessKeys(stream:string){
    return this.http.get<StreamAccessKey[]>(`/api/stream/clear_all_access_keys/${stream}`)
  }

  //


  updateInfo(id:string, title:string, description:string): Observable<StreamProject>{
    const formData = new FormData()
   
    formData.append('title',title)
    formData.append('description',description)

    return this.http.patch<StreamProject>(`/api/stream/${id}`, formData)
  }



  updateCoverImage(id:string,  image:any): Observable<StreamProject>{
    const formData = new FormData()
    formData.append('image',image, image.name)

    return this.http.patch<StreamProject>(`/api/stream/${id}`, formData)
  }

  updateRestreams(id:string, restreams:RestreamItem[]): Observable<StreamProject>{
     
    return this.http.patch<StreamProject>(`/api/stream/${id}`, {restreams})
  }

 
  deleteCoverImage(id:string): Observable<StreamProject>{
  
    return this.http.post<StreamProject>(`/api/stream/delete_cover/${id}`, {})
  }

   

    updateSettings(id:string, data:any): Observable<StreamProject>{
 
    return this.http.patch<StreamProject>(`/api/stream/${id}`, data)
  }



  updateShowDate(id:string, date:number): Observable<StreamProject>{
 
    return this.http.patch<StreamProject>(`/api/stream/${id}`, {show_date: date})
  }



  updateChatEnabled(id:string, enabled:boolean): Observable<StreamProject>{
 
    return this.http.patch<StreamProject>(`/api/stream/${id}`, {chatEnabled: enabled})
  }

 
  updatePublish(id:string, publish:boolean): Observable<StreamProject>{
 
    return this.http.patch<StreamProject>(`/api/stream/${id}`, {publish: publish})
  }
 
 
  updateSaleMode(id:string, saleMode:boolean): Observable<StreamProject>{
 
    return this.http.patch<StreamProject>(`/api/stream/${id}`, {saleMode: saleMode})
  }


  updateDonateMode(id:string, donateMode:boolean): Observable<StreamProject>{
 
    return this.http.patch<StreamProject>(`/api/stream/${id}`, {donateMode: donateMode})
  }
 
 
 
  updatePrice(id:string, price:number): Observable<StreamProject>{
 
    return this.http.patch<StreamProject>(`/api/stream/${id}`, {price: price})
  }

	updateUnlockForm(id:string, text:string, button:string): Observable<StreamProject>{
 
    return this.http.patch<StreamProject>(`/api/stream/${id}`, {accessFormButton: button, accessFormText:text })
  }



 
 
  updateQrUnlocker(id:string, qrUnlocker:boolean): Observable<StreamProject>{
 
    return this.http.patch<StreamProject>(`/api/stream/${id}`, {qrUnlocker: qrUnlocker})
  }
  
  
   updateSubtitlesEnable(id:string, enabled:boolean): Observable<StreamProject>{
 
    return this.http.patch<StreamProject>(`/api/stream/${id}`, {enabledSubtitles: enabled})
  }
  
   updateSubtitles(id:string, data:any): Observable<StreamProject>{
 
    return this.http.patch<StreamProject>(`/api/stream/update_subtitles/${id}`,  data)
  }
  
 
 
 
  getChat(stream:string){
    return this.http.get<StreamChat>(`/api/stream/get_chat/${stream}`)
  }

 
  getChatPublish(stream:string){
    return this.http.get<StreamChat>(`/api/stream/get_chat_publish/${stream}`)
  }

  getOwnChat(stream:string){
    return this.http.get<any>(`/api/stream/get_own_chat/${stream}`)
  }

 getOwnChatBanlist(id:string){
    return this.http.get<any>(`/api/stream/get_chat_bans/${id}`)
  }


 delOwnChatBanlistItem(chat_id:string,id:string){
    return this.http.post<any>(`/api/stream/del_chat_bans/${chat_id}`,{id})
  }


 getStreamDownloadLink(id:string,data:any){
    return this.http.post<any>(`/api/stream/get_download_link/${id}`,{...data})
  }

 updateStreamDownloadInfo(id:string){
    return this.http.get<any>(`/api/stream/update_download_info/${id}`)
  }

 deleteStreamRecord(id:string){
    return this.http.get<any>(`/api/stream/delete-stream-record/${id}`)
  }

  rejectStreamSignal(id:string){
    return this.http.get<any>(`/api/stream/reject-stream-signal/${id}`)
  }

 

    //patch

	  checkWatchAccessToken(streamId:string, token:string){
	    return this.http.post(`/api/stream/check_watch_access_token/${streamId}`,{
	      token
	    })
	  }

	  authWatchAccessToken(streamId:string, password: string){
	    return this.http.post(`/api/stream/auth_watch_access_token/${streamId}`,{
	      password
	    })
	  }

	  getPubliishByPublicKey(key:string):Observable<StreamProject>{

		var opts  : any = {};

		if(this.statService.hasGlobalSession()){
			opts.global_session_id = this.statService.getGlobalSession() 
		}

		 
		if(this.statService.hasGeoSession()){
			opts.geoLocation = this.statService.getGeoSession() 
		}
           
           
	    return this.http.post<StreamProject>(`/api/stream/publish/${key}`,opts).pipe(
		  
			tap((data:any)=>{
 		
				if(data?.session?.global_session_id){
					this.statService.createGlobalSession(data.session?.global_session_id)
				}

				/*if(data?.session?.local_session_id){
 					this.statService.createLocalSession(data.session?.local_session_id)
				} */

				
				if(data?.session?.geoLocation){
 					this.statService.createGeoSession(data.session.geoLocation)
				}

				//
				 

			   // return  <StreamProject>data
			})
		 

		)


	  }

  // Static Videos




  fetchStaticVideos():Observable<StreamProject[]>{
    return this.http.get<StreamProject[]>('/api/videos')
  }

 


  createStaticVideo(title?:string, image?:File): Observable<StreamProject>{
    const formData = new FormData()
    if(image){
      formData.append('image',image, image.name)
    }
   // formData.append('title',title || 'Новая трансляция')

    return this.http.post<StreamProject>('/api/videos', formData)
  }
  
  getVideoById(id:string):Observable<StreamProject>{
    return this.http.get<StreamProject>(`/api/videos/${id}`)
  }


  

  uploadVideo(video?:StreamProject, file?:File, error?:any): Observable<any>{
    const formData = new FormData()
    if(file){
      formData.append('video',file, file.name)
    }

      // formData.append('streamKey',  video.streamKey)
 

    return this.http.post<any>(`/api/videos/upload/${video._id}/${video.streamKey}`, formData,{
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(error)
    )
  }




  
  moveFromVideoToStream(video:string, stream:string):Observable<any>{
    return this.http.post<any>(`/api/stream/move_from_video_to_stream`,{
      video, stream
    })
  }

  

}
